import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import CPlist from '@/views/cplist'
import CPdetail from '@/views/cpdetail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'cplist',
      component: CPlist
    },

	{
	  path: '/cplist',
	  name: 'cplist',
	  component: CPlist
	},
  {
    path: '/cpdetail',
    name: 'cpdetail',
    component: CPdetail
  },






  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js